import type { DefaultOptionType } from 'rc-select/lib/Select';
import React from 'react';
import { Link } from 'react-router-dom';

import { prefetchOptions, toLabel } from '~/components/Columns/helpers';

import {
  type CollectionColumnDefinition,
  type ColumnDefinition,
  type ItemColumnDefinition,
  ModelColumns,
} from '~/types/components';
import type { Contact, Group, Tag } from '~/types/models';

import { tc } from '~/helpers';

const tagContactsColumn: CollectionColumnDefinition<Tag, Contact> = {
  title: 'Contacts',
  key: 'contacts',
  only: ['single'],
  sortable: false,
  type: 'collection',
  render: (value) => {
    if (!Array.isArray(value)) {
      return '';
    }
    if (value.length === 0) {
      return <em>Aucun contact</em>;
    }
    return (
      <ul style={{ margin: 0 }}>
        {value.map((c) => (
          <li key={c.id}>
            {c.firstName} {c.lastName}
          </li>
        ))}
      </ul>
    );
  },
};
const tagContactsCountColumn: ColumnDefinition<Tag> = {
  title: 'Nb de contacts',
  key: 'contactsCount',
  sortable: false,
  type: 'count',
  render: (count, record) => {
    return (
      <Link to={`/contacts?page=1&tags[0]=${record?.id ?? ''}`}>{tc('{count} contact|{count} contacts', count)}</Link>
    );
  },
};
const tagGroupColumn: ItemColumnDefinition<Tag, Group> = {
  title: 'Groupe',
  key: 'group',
  mapOptions(items: Group[]): DefaultOptionType[] {
    return items.map((i) => ({
      value: i.id,
      key: i.id,
      label: i.name,
    }));
  },
  prefetchOptions: prefetchOptions<Group>('groups', [
    {
      id: '¤',
      name: 'CSN',
      callsCount: 0,
      canLeaveMessage: false,
      contactsCount: 0,
      created: '',
      description: '',
      humanId: '',
      lastUpdated: '',
      meta: {},
      script: '',
      sequence: 0,
    },
  ]),
  render: (value) => {
    if (!value) {
      return (
        <span style={{ alignSelf: 'center' }}>
          <strong>CSN</strong>
          <br />
          <em>Accessible dans toutes les campagnes.</em>
        </span>
      );
    }

    return (
      <span style={{ alignSelf: 'center' }}>
        <strong>{value.name}</strong>
        <br />
        <em>{value.description}</em>
      </span>
    );
  },
  sortable: false,
  toLabel: toLabel('groups', 'Groupe', 'CSN'),
  type: 'item',
};
export const Columns: Array<ColumnDefinition<Tag>> = [
  {
    title: 'Nom',
    key: 'name',
    sortable: true,
    type: 'string',
  },
  {
    title: 'Description',
    key: 'description',
    sortable: false,
    type: 'string',
  },
  tagContactsColumn,
  tagContactsCountColumn,
  tagGroupColumn,
  ...ModelColumns,
];
